import { useState } from "react"
import { useTranslation } from "react-i18next"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faExpand } from "@fortawesome/free-solid-svg-icons"
import Modal from "../Modal"
import { fixImageSrc, getImageBySize } from "../../lib/media"
import { Image, ImageLarge, ImageThumbnailLink } from "./ImageThumbnail.style"
import { Button } from "../../App.styles"

const ImageThumbnail = ({ src: imgSrc, alt = '', width = 75, height = 75, skipResizes = [], ...props }) => {
    const { t } = useTranslation()
    const src = fixImageSrc(imgSrc)
    const thumbnailUrl = getImageBySize(src, width, height, skipResizes)
    const [full, setFull] = useState(false)
    return (
        <>
            <ImageThumbnailLink onClick={() => setFull(true)}>
                <Image
                    src={thumbnailUrl}
                    alt={alt}
                    {...props}
                />
            </ImageThumbnailLink>
            <Modal
                show={full}
                onDismiss={() => setFull(false)}
                size="lg"
            >
                <div className="modal-header">
                    <Button
                        tag="a"
                        className="btn--flat"
                        data-dismiss="modal"
                        aria-hidden="true"
                        href={src}
                        target="_blank"
                        rel="noreferrer"
                        color="link"
                        outline
                    >
                        <FontAwesomeIcon icon={faExpand} className="mr-2" />&nbsp;
                        {t(`Full size`)}
                    </Button>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                        onClick={() => setFull(false)}
                    >
                        ×
                    </button>
                </div>
                <div className="modal-body text-center">
                    <ImageLarge src={src} alt={alt} />
                </div>
            </Modal>
        </>
    )
}

export default ImageThumbnail